module.exports = __webpack_public_path__ + "img/product18.12443073.png";